import styles from "./GallerySlideshowItem.module.scss";
import { ISiteModuleImageGalleryItem } from "../../../../../../interfaces/ISiteModule";
import { ImgTagFromContentTypeImage } from "../../../../../../contentTypes/components/ImgTagFromContentTypeImage/ImgTagFromContentTypeImage";

interface IProps {
    item: ISiteModuleImageGalleryItem;
    itemRef?: React.Ref<HTMLDivElement>;
}

export function GallerySlideshowItem(props: IProps) {
    if (!props.item.image.image) {
        return null;
    }
    return (
        <div className={`${styles.imageWrapper}`} ref={props.itemRef}>
            <ImgTagFromContentTypeImage image={props.item.image.image} sizes="100vw" />
        </div>
    );
}
